import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'GET/commission/types': fetchList,
  // 删除
  'DELETE/commission/types/del/{id}': delApi,
  // 新增或修改
  'POST/commission/types/create_or_update': create_or_updateApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
fetchData()


// 添加
const addObj = reactive({
  item: '', type: '',
})
const isShowAdd = ref<boolean>(false)
const addHandle = () => {
  create_or_updateApi(addObj).then(() => {
    ElMessage.success('新增成功')
    isShowAdd.value = false
    fetchData()
  })
}

// 修改
const editObj = reactive({
  item: '', type: '', id: ''
})
const isShowEdit = ref<boolean>(false)
const editHandle = () => {
  create_or_updateApi(editObj).then(() => {
    ElMessage.success('修改成功')
    isShowEdit.value = false
    fetchData()
  })
}

// 删除
const delHandle = (row: {id: number, item: string}) => {
  ElMessageBox.confirm('请确认是否删除: ' + row.item, '提示', {type: 'warning'}).then(() => {
    return delApi({id: row.id})
  }).then(() => {
    ElMessage.success('删除成功')
    fetchData(MI_params)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "mb-10",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowAdd.value = true)),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      icon: "refresh",
      class: "mb-10",
      type: "info",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)())),
      disabled: _unref(MI_identify)
    }, null, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      style: {"width":"880px"},
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "提成项目",
          prop: "item",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "提成项目类型",
          prop: "type",
          formatter: (row) => row.type === 'RATIO' ? '提成率' : '金额'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => {Object.assign(_unref(editObj), row); isShowEdit.value = true},
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (delHandle(row)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowAdd).value = $event)),
      title: "新增提成项目",
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_unref(addObj).item = '', _unref(addObj).type = ''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowAdd.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addObj),
          inline: "",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "提成项目",
              prop: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).item,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addObj).item) = $event)),
                  placeholder: "请输入提成项目",
                  maxlength: "200",
                  clearable: "",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "提成项目类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addObj).type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addObj).type) = $event)),
                  placeholder: "请选择类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "利率",
                      value: "RATIO"
                    }),
                    _createVNode(_component_el_option, {
                      label: "金额",
                      value: "AMOUNT"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isShowEdit).value = $event)),
      title: "修改提成项目",
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_unref(editObj).item = '', _unref(editObj).type = ''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (isShowEdit.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (editHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(editObj),
          inline: "",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "提成项目",
              prop: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editObj).item,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(editObj).item) = $event)),
                  placeholder: "请输入提成项目",
                  maxlength: "200",
                  clearable: "",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "提成项目类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(editObj).type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(editObj).type) = $event)),
                  placeholder: "请选择类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "利率",
                      value: "RATIO"
                    }),
                    _createVNode(_component_el_option, {
                      label: "金额",
                      value: "AMOUNT"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})